import styled from 'styled-components'

import ListItem from '@components/atoms/ListItem'

export const Root = styled(ListItem)``
